import Container from './Container.styled';

export default Container;
